import { FC } from 'react';

import { IModifierData } from 'features/menu/components/product-detail/modifier/types';
import { SelectModifierFn } from 'features/menu/components/product-detail/product-customization/types';

import { ListCardGroup } from 'components/list-card-group';
import { t } from 'state/intl/translations';
import { TranslationKey } from 'state/intl/types';

import { Modifier } from '../../modifier/modifier';

export interface IModifierGroup {
  key: string;
  displayGroupName?: TranslationKey;
  modifiers: IModifierData[];
}

export type IModifierGroupProps = IModifierGroup & {
  onModifierSelectionChange: SelectModifierFn;
  isFullContainer?: boolean;
};

export const ModifierGroup: FC<IModifierGroupProps> = ({
  displayGroupName,
  modifiers,
  onModifierSelectionChange,
  isFullContainer = false,
}) => {
  return (
    <ListCardGroup
      isFullContainer={isFullContainer}
      items={modifiers}
      header={displayGroupName ? t(displayGroupName) : undefined}
      renderItem={({ item: modifierProps }: { item: IModifierData }) => (
        <Modifier
          {...modifierProps}
          key={`modifier-${modifierProps.modifier.id}`}
          onSelectionsChange={selections =>
            onModifierSelectionChange(selections, modifierProps.modifier)
          }
        />
      )}
    />
  );
};
